<template>
    <cadastro-simples-form
        endpoint="tipo-transporte"
        rota-base="/admin/tipo-transporte"
        titulo-singular="Meio de Transporte"
        :campos-extras='[
            { campo: "cod_censo", label: "Código Censo (INEP)", span: 12 }
        ]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
